import "./ToggleSwitch.scss";

interface IToggleSwitchProps {
  isEnabled?: boolean;
  onClick?: () => void;
}

const ToggleSwitch = (props: IToggleSwitchProps) => {
  const switchClasses = `toggle-switch${
    props.isEnabled ? ` toggle-on` : ` toggle-off`
  }`;

  return (
    <div className={switchClasses} onClick={props.onClick}>
      <div className="toggle-indicator"></div>
    </div>
  );
};

export default ToggleSwitch;
